import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { Error403Page } from "Infrastructure/Pages/Error403Page";
import { AuthenticatedRoute } from "./AuthenticatedRoute";

type Props = {
	requiredAccessRights: string[];
};

export const RoleProtectedRoute: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	requiredAccessRights,
}) => {
	const { data, isLoading } = useUserInfoQuery();

	if (isLoading) return <div />;

	// Check if user has at least one of the required access rights
	const hasAccess =
		data?.status === 200 &&
		requiredAccessRights.some((right) =>
			data.data.accessRightCodes?.includes(right),
		);

	if (!hasAccess) {
		return <Error403Page />;
	}

	return <AuthenticatedRoute>{children}</AuthenticatedRoute>;
};
